import { getRuntimeBaseUrl } from "../services/api/base-query";

/**
 * Resolves a file URL coming from the API (typically /api/files/{guid})
 * into an absolute URL pointing at the configured backend host.
 */
export const resolveFileUrl = (url?: string | null): string | undefined => {
  if (!url) return undefined;
  if (/^(https?:|blob:|data:)/i.test(url)) return url;
  if (url.startsWith("/api/files/")) {
    const base = (getRuntimeBaseUrl() || "").replace(/\/+$/, "");
    return `${base}${url}`;
  }
  return url;
};

/**
 * True iff the resolved URL points at this app's API host under /api/files/.
 */
export const isApiFileUrl = (resolvedUrl?: string): boolean => {
  const baseRaw = getRuntimeBaseUrl();
  if (!resolvedUrl || !baseRaw) return false;
  const base = baseRaw.replace(/\/+$/, "");
  return resolvedUrl.startsWith(`${base}/api/files/`);
};
